var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeneficios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stars-01",
    clipPath: "url(#clip0_202_6395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 9.75L5.46334 10.9267C5.66246 11.3249 5.76202 11.524 5.89502 11.6966C6.01304 11.8497 6.15031 11.987 6.30341 12.105C6.47596 12.238 6.67508 12.3375 7.07331 12.5367L8.25 13.125L7.07331 13.7133C6.67508 13.9125 6.47596 14.012 6.30342 14.145C6.15031 14.263 6.01304 14.4003 5.89502 14.5534C5.76202 14.726 5.66246 14.9251 5.46334 15.3233L4.875 16.5L4.28666 15.3233C4.08754 14.9251 3.98798 14.726 3.85498 14.5534C3.73696 14.4003 3.59969 14.263 3.44659 14.145C3.27404 14.012 3.07492 13.9125 2.67669 13.7133L1.5 13.125L2.67669 12.5367C3.07492 12.3375 3.27404 12.238 3.44658 12.105C3.59969 11.987 3.73696 11.8497 3.85498 11.6966C3.98798 11.524 4.08754 11.3249 4.28666 10.9267L4.875 9.75Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.5L12.134 3.79831C12.3455 4.34824 12.4512 4.6232 12.6157 4.85448C12.7614 5.05947 12.9405 5.23856 13.1455 5.38431C13.3768 5.54877 13.6518 5.65452 14.2017 5.86603L16.5 6.75L14.2017 7.63397C13.6518 7.84548 13.3768 7.95123 13.1455 8.11569C12.9405 8.26144 12.7614 8.44054 12.6157 8.64552C12.4512 8.8768 12.3455 9.15176 12.134 9.70169L11.25 12L10.366 9.70169C10.1545 9.15176 10.0488 8.8768 9.88431 8.64552C9.73856 8.44054 9.55947 8.26144 9.35448 8.11569C9.1232 7.95123 8.84824 7.84548 8.29831 7.63397L6 6.75L8.29831 5.86603C8.84824 5.65452 9.1232 5.54877 9.35448 5.38431C9.55946 5.23856 9.73856 5.05947 9.88431 4.85448C10.0488 4.6232 10.1545 4.34824 10.366 3.79831L11.25 1.5Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_6395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficios);
export default __webpack_public_path__ + "static/media/beneficios.6d90c5f09fab2e60dbc4654c63095574.svg";
export { ForwardRef as ReactComponent };